import CardRoute from '@/pages/example/CardRoute.vue';

export const mfRoutes = [
  {
    path: '/sights/:slug',
    name: 'attractions-card',
    component: CardRoute,
  },
];

export default mfRoutes;
